// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-checklist-progress-stepper-bar {
  position: relative;
  font-weight: normal;
}
.fi-checklist-progress-stepper-bar.inactive .progress-place {
  background-color: var(--fi-checklist-grey);
}
.fi-checklist-progress-stepper-bar .progress-place {
  clear: both;
  background-color: var(--fi-checklist-red);
  height: 40px;
  position: relative;
}
.fi-checklist-progress-stepper-bar .progress-place .progress-bar {
  background-color: var(--fi-checklist-deep-green);
}
.fi-checklist-progress-stepper-bar .progress-text {
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  line-height: 40px;
  font-size: 20px;
  text-align: center;
  color: var(--fi-color-white);
}
.fi-checklist-progress-stepper-bar .progress-description {
  color: var(--fi-color-light);
  background-color: var(--fi-color-white);
  padding: 5px;
}`, "",{"version":3,"sources":["webpack://./Source/app/checklist/progress-stepper-bar/progress-stepper-bar.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,mBAAA;AACJ;AAEQ;EACI,0CAAA;AAAZ;AAII;EACI,WAAA;EACA,yCAAA;EACA,YAAA;EACA,kBAAA;AAFR;AAIQ;EACI,gDAAA;AAFZ;AAMI;EACI,kBAAA;EACA,SAAA;EACA,MAAA;EACA,2BAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,4BAAA;AAJR;AAOI;EACI,4BAAA;EACA,uCAAA;EACA,YAAA;AALR","sourcesContent":[".fi-checklist-progress-stepper-bar {\r\n    position: relative;\r\n    font-weight: normal;\r\n\r\n    &.inactive {\r\n        .progress-place {\r\n            background-color: var(--fi-checklist-grey);\r\n        }\r\n    }\r\n\r\n    .progress-place {\r\n        clear: both;\r\n        background-color: var(--fi-checklist-red);\r\n        height: 40px;\r\n        position: relative;\r\n\r\n        .progress-bar {\r\n            background-color: var(--fi-checklist-deep-green);\r\n        }\r\n    }\r\n\r\n    .progress-text {\r\n        position: absolute;\r\n        left: 50%;\r\n        top: 0;\r\n        transform: translateX(-50%);\r\n        line-height: 40px;\r\n        font-size: 20px;\r\n        text-align: center;\r\n        color: var(--fi-color-white);\r\n    }\r\n\r\n    .progress-description {\r\n        color: var(--fi-color-light);\r\n        background-color: var(--fi-color-white);\r\n        padding: 5px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
